import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { navLinks } from "@/mocks/site";
import { scrollToSubscribe } from "@/utils/subscribeNav";

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/80 bg-background-50/95 backdrop-blur">
      <div className="hidden w-full items-center justify-between gap-6 bg-foreground-950 px-4 py-1.5 text-[12px] text-background-200 md:flex md:px-6">
        <p className="truncate">爆料在线 · 独家内容编辑部｜先核实，后发布</p>
        <p className="flex items-center gap-4 whitespace-nowrap">
          <span className="flex items-center gap-1">
            <i className="ri-shield-check-line text-accent-400" aria-hidden="true" />
            信源可追溯
          </span>
          <a href="mailto:contact@baoliao-online.example.com" className="cursor-pointer hover:text-accent-300">
            爆料邮箱
          </a>
        </p>
      </div>

      <div className="mx-auto flex w-full max-w-shell items-center justify-between px-4 py-3 md:px-6">
        <Link to="/" className="flex items-center gap-2.5" onClick={() => setOpen(false)}>
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-megaphone-fill text-lg" aria-hidden="true" />
          </span>
          <span className="leading-none">
            <span className="block font-heading text-lg font-black tracking-tight text-foreground-950">
              爆料在线
            </span>
            <span className="mt-0.5 block text-[11px] tracking-[0.25em] text-secondary-600">
              EXCLUSIVE
            </span>
          </span>
        </Link>

        <nav aria-label="主导航" className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) =>
                `cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            onClick={(event) => {
              event.preventDefault();
              scrollToSubscribe(navigate);
            }}
            className="hidden cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:flex"
          >
            <i className="ri-mail-add-line" aria-hidden="true" />
            订阅独家
          </a>
          <button
            type="button"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            onClick={() => setOpen((prev) => !prev)}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true" />
          </button>
        </div>
      </div>

      {open && (
        <nav
          aria-label="移动端导航"
          className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden"
        >
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `block cursor-pointer rounded-md px-3 py-2.5 text-sm font-medium ${
                  isActive
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
          <a
            href="#subscribe"
            onClick={(event) => {
              event.preventDefault();
              setOpen(false);
              scrollToSubscribe(navigate);
            }}
            className="mt-2 flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
          >
            <i className="ri-mail-add-line" aria-hidden="true" />
            订阅独家
          </a>
        </nav>
      )}
    </header>
  );
}